import { FleekError } from './FleekError';

type IpfsDenylistUpdateWorkflowTriggerFailedErrorOptions = {
  error: string;
};

export class IpfsDenylistUpdateWorkflowTriggerFailedError extends FleekError<IpfsDenylistUpdateWorkflowTriggerFailedErrorOptions> {
  public name = 'IpfsDenylistUpdateWorkflowTriggerFailedError';

  toString = () => {
    return `Failed to trigger IPFS denylist update workflow: ${this.data.error}`;
  };
}
